import { PublishedModule } from '../modules/published';

export function PublishedArtifact() {
  return <PublishedModule kind="artifact" />;
}

export default PublishedArtifact;
